import { AclEntriesStatusTooltipContent, AclEntriesStatusTooltipProps, AclEntriesTooltipBaseEntitiesConfig } from 'common/types/TypeDefs';
import dayjs from 'dayjs';

export const getDatesInfo = (startDateString?: string, endDateString?: string) => {
    const startDate = startDateString ? dayjs(startDateString).format('MM/DD/YYYY') : null;
    const endDate = endDateString ? dayjs(endDateString).format('MM/DD/YYYY') : null;
    if(startDate && endDate) {
        return `${startDate} - ${endDate}`;
    }
    if(!startDate) {
        return 'always active';
    }
    if(!endDate) {
        return `from ${startDate}`;
    }
};

function hasProperty<X extends Record<string, unknown>, Y extends PropertyKey>
(obj: X, prop: Y): obj is X & Record<Y, unknown> {
    return prop in obj;
}

export const _createStatusTooltipContentList = (
    statusProps: AclEntriesStatusTooltipProps,
    config: AclEntriesTooltipBaseEntitiesConfig[]
): AclEntriesStatusTooltipContent[] => {
    return config.map(({ entityName, title, testId, inactiveTestId, inactiveReasonMessage }) => {
        const startDateProp = `${entityName}StartDate`;
        const endDateProp = `${entityName}EndDate`;
        const inactiveProp = `${entityName}Inactive`;

        const startDate = hasProperty(statusProps, startDateProp) ? (statusProps[startDateProp]) as string : undefined;
        const endDate = hasProperty(statusProps, endDateProp) ? (statusProps[endDateProp]) as string : undefined;
        const inactive = hasProperty(statusProps, inactiveProp) ? (statusProps[inactiveProp]) as boolean : undefined;

        return {
            message: `${title}: ${getDatesInfo(startDate, endDate)}`,
            testId,
            inactiveTestId,
            startDate,
            endDate,
            inactive,
            inactiveReasonMessage
        };
    });
};
